import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
      count: 0,
      title: '',
      token: null
    },
    mutations: {
      increment (state) {
        state.count++
      },
      title (state, data) {
        state.title = data
      }
    }
  })

export default store
